import script from "./pageNotFound.vue?vue&type=script&setup=true&lang=js"
export * from "./pageNotFound.vue?vue&type=script&setup=true&lang=js"

import "./pageNotFound.vue?vue&type=style&index=0&id=59753217&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59753217"]])

export default __exports__